import { FC } from 'react'

import Icon from '~/src/components/generic/PhosphorIcons/Icon'

import {
  Notification,
  NotificationDisplayType,
} from '~/src/components/shared/Notification/types'

import colors from '~/config/colorsScheme'
import { tw } from '~/lib/utils'

type Props = {
  notification: Notification
  displayType: NotificationDisplayType
  unread: boolean
}

const NotificationMeta: FC<Props> = ({ notification, displayType, unread }) => {
  return (
    <div className="flex items-center justify-start space-x-2">
      <div
        className={tw(
          'flex items-center justify-start space-x-1 text-body-s-emphasized text-secondary',
          !unread && 'font-medium'
        )}
      >
        <Icon color={colors.gray[600]} name="ArticleIcon" size="16" />
        <span className="underline underline-offset-1">
          {notification.load?.ryderNumber}
        </span>
      </div>

      {notification.driver?.fullname && (
        <div className="flex items-center space-x-1">
          <Icon color={colors.gray[600]} name="UserSquareIcon" size="16" />
          <span
            className={tw(
              'truncate text-body-s-emphasized text-secondary underline underline-offset-1',
              !unread && 'font-medium',
              displayType === 'dropdown' ? 'w-28' : 'w-16'
            )}
          >
            {notification.driver.fullname}
          </span>
        </div>
      )}
    </div>
  )
}

export default NotificationMeta
